import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { SuborganizationStore } from './+state/suborganization.store';
import { SuborganizationService } from './service/suborganization.service';

export function provideSuborganization(): EnvironmentProviders {
  return makeEnvironmentProviders([SuborganizationStore, SuborganizationService]);
}
